import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import {
    storePleitoVeiculo
} from '~/store/modules/pleitoveiculo/actions';
import { Form } from '@unform/web';

import * as S from './styles';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';
import { t, parseDateString } from '~/helpers';

import api from '~/services/api';
import { closeDialog } from '~/store/modules/dialog/actions';
import { Input, DateTime, InputText, Select, Autocomplete } from '~/components/Form';
import { SelectComplete } from '~/componentslocal';
import { isEmpty, isNumber } from 'lodash';

export default function CreateOrUpdate({ create, data, reference, ...props }) {
    const dispatch = useDispatch();

    const redux = useSelector((state) => state.pleitoveiculo);


    const [dataHoraEnvioVisibility, setDataHoraEnvioVisibility] = useState(false)
    const [dataHoraAutorizadoNFVisibility, setDataHoraAutorizadoNFVisibility] = useState(false)
    const [dataHoraPagamentoNFVisiblity, setDataHoraPagamentoNFVisibility] = useState(false)
    const [dataHoraCanceladoVisibility, setDataHoraCanceladoVisibility] = useState(false)

    const [veiculo, setVeiculo] = useState({})


    const initials = create ? data : { ...data };


    const handleToggleVisibilityDataHoraEnvio = useCallback(() => {
        setDataHoraEnvioVisibility(state => !state)
    }, [])

    const handleToggleVisibilityDataHoraAutorizadoNF = useCallback(() => {
        setDataHoraAutorizadoNFVisibility(state => !state)
    }, [])

    const handleToggleVisibilityDataHoraPagamentoNF = useCallback(() => {
        setDataHoraPagamentoNFVisibility(state => !state)
    }, [])

    const handleToggleVisibilityDataHoraCancelado = useCallback(() => {
        setDataHoraCanceladoVisibility(state => !state)
    }, [])

    const handleTestValorPleito = useCallback((value) => {
        const regex1 = /^((\d+\,\d+){1})$/;
        const regex2 = /^(\d+)$/;
        const regex3 = /^((\d+\.\d+){1})$/;

        if (regex1.test(value) || regex2.test(value) || regex3.test(value) || isEmpty(value)) {
            return true
        }
        return false
    }, [])

    const handleValidatePlaca = useCallback(async (veic_placa) => {
        const response = await api.get(`pleito/buscaveiculopleito/${veic_placa}`)
        if (!isEmpty(response.data)) {
            return response.data
        } else {
            return {}
        }

    }, [])

    async function handleSubmit(params) {
        try {

            const veic = params.veic_placa ? await handleValidatePlaca(params.veic_placa) : {}

            const schema = Yup.object().shape({
                plei_datahora_pleito: Yup.date()
                    .transform((_, value) => parseDateString(value))
                    .typeError(t('s.geral.validacao.campoobrigatorio'))
                    .required(t('s.geral.validacao.campoobrigatorio')),
                veic_placa: Yup.string()
                    .test('teste placa', 'Veículo não encontrado', _ => !isEmpty(veic))
                    .typeError(t('s.geral.validacao.campoobrigatorio'))
                    .required(t('s.geral.validacao.campoobrigatorio')),
                plsi_codigo: Yup.number()
                    .typeError(t('s.geral.validacao.campoobrigatorio'))
                    .required(t('s.geral.validacao.campoobrigatorio')),
                orga_codigo: Yup.number()
                    .typeError(t('s.geral.validacao.campoobrigatorio'))
                    .required(t('s.geral.validacao.campoobrigatorio')),
                plei_numero_laudo: Yup.string()
                    .typeError(t('s.geral.validacao.campoobrigatorio')),
                plei_valor_pleito: Yup.string()
                    .test('teste valor pleito', 'Valor Inválido', value => handleTestValorPleito(value))
                    .typeError(t('s.geral.validacao.campoobrigatorio')),
                plei_datahora_envio: dataHoraEnvioVisibility ?
                    Yup.date()
                        .transform((_, value) => parseDateString(value))
                    :
                    Yup.date()
                        .transform((_, value) => parseDateString(value))
                        .nullable(),
                plei_status: Yup.string()
                    .typeError(t('s.geral.validacao.campoobrigatorio'))
                    .required(t('s.geral.validacao.campoobrigatorio')),
                plei_datahora_autorizado_nf: dataHoraAutorizadoNFVisibility ?
                    Yup.date()
                        .transform((_, value) => parseDateString(value))
                        .typeError(t('s.geral.validacao.campoobrigatorio'))
                    :
                    Yup.date()
                        .transform((_, value) => parseDateString(value))
                        .nullable(),
                plei_numero_pedido: Yup.string()
                    .typeError(t('s.geral.validacao.campoobrigatorio'))
                    .nullable(),
                plei_nota_fiscal_servico: Yup.string()
                    .typeError(t('s.geral.validacao.campoobrigatorio'))
                    .nullable(),
                plei_nota_fiscal_produto: Yup.string()
                    .typeError(t('s.geral.validacao.campoobrigatorio'))
                    .nullable(),
                plei_datahora_pagamento_nota_fiscal: Yup.date()
                    .transform((_, value) => parseDateString(value))
                    .typeError(t('s.geral.validacao.campoobrigatorio')),
                plei_datahora_cancelado: Yup.date()
                    .transform((_, value) => parseDateString(value))
                    .typeError(t('s.geral.validacao.campoobrigatorio')),
                plei_observacao: Yup.string()
                    .typeError(t('s.geral.validacao.campoobrigatorio'))
                    .nullable()
            })
            await schema.validate(params, {
                abortEarly: false,
            })

            let obj = {
                ...params,
                plei_codigo: undefined,
                plei_datahora_autorizado_nf: dataHoraAutorizadoNFVisibility ? params.plei_datahora_autorizado_nf : undefined,
                plei_datahora_cancelado: dataHoraCanceladoVisibility ? params.plei_datahora_cancelado : undefined,
                plei_datahora_envio: dataHoraEnvioVisibility ? params.plei_datahora_envio : undefined,
                plei_datahora_pagamento_nota_fiscal: dataHoraPagamentoNFVisiblity ? params.plei_datahora_pagamento_nota_fiscal : undefined,
                plei_valor_pleito: isEmpty(params.plei_valor_pleito) ? 0.00 : Number(params.plei_valor_pleito.replace(',', '.')),
                plei_tipo: 'V',
                veic_placa: veic.veic_placa,
            }

            dispatch(storePleitoVeiculo(obj, redux.params))
            dispatch(dispatch(closeDialog()));
            reference.current.setErrors({})
        } catch (err) {
            const validationErrors = {};

            if (err instanceof Yup.ValidationError) {
                err.inner.forEach((error) => {
                    validationErrors[error.path] = error.message.replace(
                        `${error.path} `,
                        ''
                    );
                });

                reference.current.setErrors(validationErrors);
            }
        }
    }


    return (
        <>
            <Form ref={reference} onSubmit={handleSubmit}>
                <DateTime name="plei_datahora_pleito" label="Data hora pleito" time />
                <InputText name="veic_placa" label="Placa veículo"
                    mask="*******"
                    placeholder=""

                />

                <SelectComplete
                    name="plsi_codigo"
                    unique="plsi_codigo"
                    label="plsi_descritivo"
                    title="Situação"
                    url="pleito/pleitosituacao"
                    params={{
                        wherefield: ['plsi_tipo'],
                        valuewherefield: ['v'],
                        typewherefield: ['EQUALS']
                    }}
                />
                <Autocomplete
                    name="orga_codigo"
                    label="orga_nome"
                    title="Órgão"
                    url="orgaos"
                    unique="orga_codigo"
                />
                <InputText name="plei_numero_laudo" label="Número do Laudo:" placeholder="" mask="*********" />
                <InputText
                    name="plei_valor_pleito"
                    label="Valor do Pleito:"
                    mask="dddddddd"
                    placeholder=""
                />
                <S.ContainerEyer>
                    {dataHoraEnvioVisibility ?
                        <>
                            <DateTime name="plei_datahora_envio" label="Data de envio do pleito:" time />

                            <IconButton onClick={handleToggleVisibilityDataHoraEnvio}>
                                <Visibility />
                            </IconButton>
                        </>
                        :
                        <>
                            <Input name="plei_datahora_envio" label="Data de envio do pleito" value="00/00/0000 00:00" disabled />

                            <IconButton onClick={handleToggleVisibilityDataHoraEnvio}>
                                <VisibilityOff />
                            </IconButton>
                        </>}
                </S.ContainerEyer>
                <Select
                    name="plei_status"
                    label="Status"
                    options={[
                        { value: 'A', label: 'Aberto' },
                        { value: 'C', label: 'Cancelado' },
                        { value: 'F', label: 'Autorizado Nota Fiscal' },
                        { value: 'P', label: 'Pago' },
                    ]}

                />
                <S.ContainerEyer>
                    {dataHoraAutorizadoNFVisibility ?
                        <>
                            <DateTime name="plei_datahora_autorizado_nf" label="Data autorização NF" time />

                            <IconButton onClick={handleToggleVisibilityDataHoraAutorizadoNF}>
                                <Visibility />
                            </IconButton>
                        </>
                        :
                        <>
                            <Input name="plei_datahora_autorizado_nf" label="Data autorização NF" value="00/00/0000 00:00" disabled />

                            <IconButton onClick={handleToggleVisibilityDataHoraAutorizadoNF}>
                                <VisibilityOff />
                            </IconButton>
                        </>}

                </S.ContainerEyer>

                <InputText name="plei_numero_pedido" label="Número do pedido:" placeholder="" mask="999999999" />
                <InputText name="plei_nota_fiscal_servico" label="Número NF Serviço:" placeholder="" mask="999999999" />
                <InputText name="plei_nota_fiscal_produto" label="Número NF Produto:" placeholder="" mask="999999999" />
                <S.ContainerEyer>
                    {dataHoraPagamentoNFVisiblity ?
                        <>
                            <DateTime name="plei_datahora_pagamento_nota_fiscal" label="Data Pagamento NF" time />
                            <IconButton onClick={handleToggleVisibilityDataHoraPagamentoNF}>
                                <Visibility />
                            </IconButton>
                        </>

                        :
                        <>

                            <Input name="plei_datahora_pagamento_nota_fiscal" label="Data Pagamento NF" value="00/00/0000 00:00" disabled />

                            <IconButton onClick={handleToggleVisibilityDataHoraPagamentoNF}>
                                <VisibilityOff />
                            </IconButton>
                        </>

                    }
                </S.ContainerEyer>
                <S.ContainerEyer>
                    {dataHoraCanceladoVisibility ?
                        <>
                             { /* //<DateTime name="plei_datahora_cancelado" label="Data Cancelamento" time /> */ }
                            <DateTime name="plei_datahora_cancelado" label="Data Cancelamento" />
                            <IconButton onClick={handleToggleVisibilityDataHoraCancelado}>
                                <Visibility />
                            </IconButton>
                            

                        </>
                        :
                        <>

                            <Input name="plei_datahora_cancelado" label="Data Cancelamento" value="00/00/0000 00:00" disabled />

                            <IconButton onClick={handleToggleVisibilityDataHoraCancelado}>
                                <VisibilityOff />
                            </IconButton>
                        </>
                    }

                </S.ContainerEyer>
                <Input
                    name="plei_observacao"
                    label="Observação:"
                    inputProps={{ maxLength: 500 }}
                    multiline
                    rows={5}
                />
            </Form>
        </>
    );
}

CreateOrUpdate.propTypes = {
    reference: PropTypes.objectOf(PropTypes.any).isRequired,
    create: PropTypes.bool.isRequired,
    data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
    data: {},
};
